import { render, staticRenderFns } from "./CustomfieldHistory.vue?vue&type=template&id=5508b40e&"
import script from "./CustomfieldHistory.vue?vue&type=script&lang=js&"
export * from "./CustomfieldHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports